import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Stack,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Iconify } from "src/components";
import ToggleWeekDays from "./ToggleWeekDays";
import ReactDatePicker from "src/components/task-components/ReactDatePicker";
import moment from "moment";

export default function CustomRecurrenceDialog({
  open,
  onClose,
  startDate,
  intervalValue,
  setIntervalValue,
  occurrenceValue,
  setOccurrenceValue,
  intervalType,
  setIntervalType,
  days,
  setDays,
  option,
  setOption,
  endDate,
  setEndDate,
  monthlySelectedDays,
  setMonthlySelectedDays,
  setYearlyFormattedDate,
  setHasChanges
}) {
  // --------------------------------------------
  const [openDatePicker, setOpenDatePicker] = useState(false);
  // ------------------ "yearly"
  const [selectedMonthYearly, setSelectedMonthYearly] = useState("");
  const [selectedDayYearly, setSelectedDayYearly] = useState("");
  // ----------------- "monthly"
  const [monthDays, setMonthDays] = useState([]);
  // -----------------------------------------

  const handleMonthChangeYearly = (event) => {
    setSelectedMonthYearly(event.target.value);
  };

  const handleDayChangeYearly = (event) => {
    setSelectedDayYearly(event.target.value);
  };

  const handleOpen = () => {
    setOpenDatePicker(true);
  };

  const handleRadioChange = (event) => {
    setOption(event.target.value);
  };

  const handleIntervalChange = (event) => {
    setIntervalValue(event.target.value);
  };

  const handleUnitChange = (event) => {
    setIntervalType(event.target.value);
  };

  const handleOccurrenceChange = (event) => {
    setOccurrenceValue(event.target.value);
  };

  const handleDone = () => {
    setHasChanges(true);
    onClose();
  };
  const handleCancel = () => {
    onClose();
    setHasChanges(false);
    // setSelectedDayYearly("");
    // setSelectedMonthYearly("");
  };

  const handleDayClick = (day) => {
    // choose one day------------------
    if (monthlySelectedDays[0] === day) {
      setMonthlySelectedDays([]);
    } else {
      setMonthlySelectedDays([day]);
    }
    // choose multiple days ---------
    // if (monthlySelectedDays.includes(day)) {
    //   setMonthlySelectedDays(monthlySelectedDays.filter((d) => d !== day));
    // } else {
    //   setMonthlySelectedDays([...monthlySelectedDays, day]);
    // }
  };
  const handleLastDayClick = () => {
    setMonthlySelectedDays([-1]);
  };

  // ================= Yearly selected month days =================
  const getDaysInMonth = (month) => {
    const monthIndex = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ].indexOf(month);

    if (monthIndex === -1) return 31;

    const year = new Date().getFullYear();
    return new Date(year, monthIndex + 1, 0).getDate(); // correct days, leap-year included
  };
  const renderDayOptions = (selectedMonthYearly) => {
    const days = getDaysInMonth(selectedMonthYearly);
    const items = [];
    for (let i = 1; i <= days; i++) {
      items.push(
        <MenuItem key={i} value={i}>
          {i}
        </MenuItem>
      );
    }
    return items;
  };

  // <================ useFffect ================>
  useEffect(() => {
    if (startDate) {
      setEndDate(startDate);
    }
  }, [startDate]);
  useEffect(() => {
    if (startDate) {
      const lastDay = moment(startDate).endOf("month").date();
      const days = [];
      for (let i = 1; i <= lastDay; i++) {
        days.push(i);
      }
      setMonthDays(days);
    }
  }, [startDate]);
  //--------------- Yearly selected month days
  useEffect(() => {
    if (selectedMonthYearly && selectedDayYearly) {
      const year = moment().year();
      const monthIndex = moment().month(selectedMonthYearly).month(); // 0-indexed
      const monthNumber = (monthIndex + 1).toString().padStart(2, "0");
      const dayNumber = selectedDayYearly.toString().padStart(2, "0");

      const formatted = `${year}-${monthNumber}-${dayNumber}`;
      setYearlyFormattedDate(formatted);
      console.log(formatted, "Yearly formatted date");
    }
  }, [selectedMonthYearly, selectedDayYearly]);

  return (
    <>
      <Dialog
        className="custom-recurrence-dialog"
        sx={{ "& .MuiDialog-paper": { width: 350 } }}
        // fullWidth
        open={open}
        onClose={handleCancel}
      >
        <DialogTitle>Custom Recurrence</DialogTitle>
        <DialogContent className="pt-2">
          <Box display="flex" alignItems="center">
            <Typography fontWeight={500} paddingRight="15px" variant="body2">
              Repeat every
            </Typography>
            <TextField
              value={intervalValue}
              onChange={handleIntervalChange}
              type="number"
              size="small"
              sx={{ width: 55, mr: 1.5 }}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "-" ||
                  e.key === "+" ||
                  e.key === " "
                ) {
                  e.preventDefault();
                }
              }}
            />
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <Select
                size="small"
                value={intervalType}
                onChange={handleUnitChange}
              >
                <MenuItem value="daily">Day</MenuItem>
                <MenuItem value="weekly">Week</MenuItem>
                <MenuItem value="monthly">Month</MenuItem>
                <MenuItem value="yearly">Year</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {intervalType === "weekly" && (
            <div className="mt-2">
              <Stack spacing={1}>
                <Typography
                  fontWeight={500}
                  paddingRight="15px"
                  variant="body2"
                >
                  Repeat on
                </Typography>
                <ToggleWeekDays days={days} setDays={setDays} />
              </Stack>
            </div>
          )}
          {intervalType === "monthly" && (
            <div className="mt-2">
              <Typography fontWeight={500} variant="body2">
                Select Repeating Days
              </Typography>

              {/* Month Days  */}
              <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                {monthDays.map((day) => (
                  <Button
                    className="custom-month-btn"
                    key={day}
                    variant={
                      monthlySelectedDays.includes(day)
                        ? "contained"
                        : "outlined"
                    }
                    size="small"
                    onClick={() => handleDayClick(day)}
                  >
                    {day}
                  </Button>
                ))}
                <Button
                  className="custom-month-btn"
                  variant={
                    monthlySelectedDays.includes(-1) ? "contained" : "text"
                  }
                  size="small"
                  onClick={handleLastDayClick}
                >
                  Last Day
                </Button>
              </Box>
            </div>
          )}

          {intervalType === "yearly" && (
            <Box mt={1}>
              <Typography fontWeight={500} variant="body2">
                Repeat on
              </Typography>
              <Stack direction="row" spacing={2} alignItems="center" mt={1}>
                {/* Dropdown for yearly Month Selection */}
                <FormControl fullWidth size="small">
                  <Select
                    sx={{ fontSize: "12px" }}
                    value={selectedMonthYearly || ""}
                    onChange={handleMonthChangeYearly}
                    displayEmpty
                    renderValue={(selectedMonthYearly) =>
                      selectedMonthYearly ? selectedMonthYearly : "Choose Month"
                    }
                  >
                    {[
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ].map((month) => (
                      <MenuItem key={month} value={month}>
                        {month}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Dropdown for yearly Day Selection */}
                <FormControl fullWidth size="small">
                  <Select
                    sx={{ fontSize: "12px" }}
                    value={selectedDayYearly || ""}
                    onChange={handleDayChangeYearly}
                    displayEmpty
                    renderValue={(selectedDayYearly) =>
                      selectedDayYearly ? selectedDayYearly : "Choose Day"
                    }
                  >
                    {renderDayOptions(selectedMonthYearly)}
                  </Select>
                </FormControl>
              </Stack>
            </Box>
          )}

          <div className="mt-3">
            <Stack spacing={0}>
              <Typography fontWeight={500} paddingRight="15px" variant="body2">
                Ends
              </Typography>
              <FormControl>
                <RadioGroup
                  name="reccurence-options"
                  value={option}
                  onChange={handleRadioChange}
                >
                  {/* <FormControlLabel
                    className="recurrence-radio"
                    value="never"
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "12px" }}>Never</span>}
                  /> */}

                  <div className="d-flex align-items-center justify-content-between">
                    <FormControlLabel
                      className="recurrence-radio"
                      value="after"
                      control={<Radio size="small" />}
                      label={<span style={{ fontSize: "12px" }}>After</span>}
                    />
                    <div className="occur-rences">
                      <TextField
                        value={occurrenceValue}
                        onChange={handleOccurrenceChange}
                        type="number"
                        size="small"
                        sx={{ width: 55, paddingTop: "4px" }}
                        disabled={option === "never" || option === "on"}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === " "
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />

                      <Typography
                        paddingRight="15px"
                        variant="body2"
                        sx={{
                          color: option !== "after" && "#9e9e9e",
                        }}
                      >
                        Occurrence
                      </Typography>
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-between mt-1">
                    <FormControlLabel
                      className="recurrence-radio"
                      value="on"
                      control={<Radio size="small" />}
                      label={<span style={{ fontSize: "12px" }}>On</span>}
                    />
                    <ReactDatePicker
                      isOpen={openDatePicker}
                      setIsOpen={setOpenDatePicker}
                      handleOpen={handleOpen}
                      timeDate={endDate}
                      setTimeDate={setEndDate}
                      disabled={option === "never" || option === "after"}
                      disablePastDates={false}
                    />
                  </div>
                </RadioGroup>
              </FormControl>
            </Stack>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary" variant="text">
            Cancel
          </Button>
          <Button onClick={handleDone} color="primary" variant="contained">
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
